const kk = {
  "nav_home": "Басты бет",
  "nav_about": "Біз туралы",
  "nav_services": "Қызметтер",
  "nav_blog": "Блог",
  "nav_login": "Кіру",
  "nav_register": "Тіркелу",
  "nav_dashboard": "Кабинет",
  "nav_logout": "Шығу",
  "hero_title": "Жаһандық инвойс-қаржыландыру платформасы",
  "hero_subtitle": "TradeFlow - трансшекаралық B2B инвойс-қаржыландыруды тарту, андеррайтинг жасау және сүйемелдеу үшін цифрлық платформа. Қаржыландыруды банктер, факторинг компаниялары және private credit серіктестері береді.",
  "hero_cta": "Демо-мәмілені көру",
  "hero_secondary": "Қалай жұмыс істейді",
  "scoring_title": "Алдын ала бағалау",
  "scoring_subtitle": "Иллюстрациялық мәміле бойынша қаржыландыру лимитін 2 минутта бағалау",
  "scoring_company": "Компания атауы",
  "scoring_revenue": "Жылдық түсім ($)",
  "scoring_years": "Бизнестегі жылдар саны",
  "scoring_industry": "Сала",
  "scoring_country": "Ел",
  "scoring_invoices": "Төленбеген шоттар ($)",
  "scoring_financial": "Қаржылық есеп бар",
  "scoring_bank": "Банк үзінділері бар",
  "scoring_submit": "Лимитті есептеу",
  "scoring_result_title": "Бағалау нәтижесі",
  "scoring_score": "Скоринг балы",
  "scoring_risk": "Тәуекел деңгейі",
  "scoring_limit": "Алдын ала лимит",
  "scoring_recommendations": "Ұсынымдар",
  "risk_low": "Төмен",
  "risk_moderate": "Орташа",
  "risk_elevated": "Жоғарылау",
  "risk_high": "Жоғары",
  "industry_manufacturing": "Өндіріс",
  "industry_trade": "Сауда",
  "industry_services": "Қызметтер",
  "industry_logistics": "Логистика",
  "industry_agriculture": "Ауыл шаруашылығы",
  "industry_it": "IT",
  "industry_construction": "Құрылыс",
  "industry_other": "Басқа",
  "auth_login_title": "Кіру",
  "auth_register_title": "Тіркелу",
  "auth_email": "Email",
  "auth_password": "Пароль",
  "auth_confirm_password": "Құпиясөзді растаңыз",
  "auth_full_name": "Толық аты-жөні",
  "auth_company": "Компания атауы",
  "auth_phone": "Телефон",
  "auth_role": "Аккаунт түрі",
  "auth_submit_login": "Кіру",
  "auth_submit_register": "Тіркелу",
  "auth_no_account": "Аккаунтыңыз жоқ па?",
  "auth_have_account": "Аккаунтыңыз бар ма?",
  "auth_social_login": "Кіру тәсілі",
  "auth_coming_soon": "Жақында",
  "role_client_buyer": "Сатып алушы / импорттаушы",
  "role_client_seller": "Сатушы / экспорттаушы",
  "role_agent": "Ориджинатор / агент",
  "role_partner_investor": "Инвестор",
  "role_partner_institution": "Банк / қаржы серіктесі",
  "dash_overview": "Шолу",
  "dash_documents": "Құжаттар",
  "dash_invoices": "Шот-фактуралар",
  "dash_deals": "Мәмілелер",
  "dash_offers": "Ұсыныстар",
  "dash_blog": "Блог",
  "dash_settings": "Баптаулар",
  "dash_analytics": "Аналитика",
  "dash_users": "Пайдаланушылар",
  "dash_scoring": "Скоринг",
  "stats_total_financed": "Барлығы қаржыландырылды",
  "stats_active_deals": "Белсенді мәмілелер",
  "stats_exposure": "Қолжетімді лимит",
  "stats_pending": "Қаралуда",
  "action_upload": "Жүктеу",
  "action_create": "Жасау",
  "action_edit": "Өңдеу",
  "action_delete": "Жою",
  "action_view": "Көру",
  "action_approve": "Мақұлдау",
  "action_reject": "Қабылдамау",
  "action_fund": "Қаржыландыру",
  "action_publish": "Жариялау",
  "action_save": "Сақтау",
  "action_cancel": "Болдырмау",
  "section_stories": "Демо дәлелі",
  "section_offers": "Серіктестік мүмкіндіктері",
  "section_logistics": "Логистические услуги",
  "section_how_it_works": "Қалай жұмыс істейді",
  "section_partners": "Наши партнеры",
  "footer_about": "Платформа туралы",
  "footer_contact": "Байланыс",
  "footer_terms": "Пайдалану шарттары",
  "footer_privacy": "Құпиялық саясаты",
  "footer_copyright": "© 2024 TradeFlow. Барлық құқықтар қорғалған.",
  "msg_success": "Сәтті",
  "msg_error": "Қате",
  "msg_loading": "Жүктелуде...",
  "msg_no_data": "Деректер жоқ",
  "nav": {
    "demo": "Демо"
  },
  "hero": {
    "badge": "Жаһандық инвойс-қаржыландыру платформасы",
    "statSpeedValue": "60д",
    "statSpeedLabel": "Типичный срок платежа",
    "statAdvanceValue": "80%",
    "statAdvanceLabel": "Примерная ставка аванса",
    "statPartnersValue": "4",
    "statPartnersLabel": "Участника процесса",
    "approvedTitle": "Демо-сделка одобрена",
    "approvedMeta": "Заявка на финансирование $160,000"
  },
  "demo": {
    "badge": "Иллюстрациялық демо-мәміле",
    "title": "Бір трансшекаралық инвойс: өтінімнен өтеуге дейін",
    "subtitle": "Бұл нақты мәміле емес. Бұл TradeFlow банктер, факторинг компаниялары және private credit серіктестері үшін ұйымдастырып, андеррайтинг жасап, қызмет көрсете алатын транзакция үлгісі.",
    "caseTitle": "Демо-кейс: счет за промышленное оборудование",
    "sellerLabel": "Китайский продавец",
    "buyerLabel": "Казахстанский покупатель",
    "corridorLabel": "Corridor",
    "statusLabel": "Статус",
    "metrics": {
      "invoice": "Счет",
      "term": "Срок оплаты",
      "advance": "Аванс",
      "financing": "Требуемое финансирование",
      "pricing": "Ориентир ставки",
      "fee": "Комиссия TradeFlow"
    },
    "roles": {
      "seller": {
        "title": "Seller view",
        "items": [
          "Invoice submitted",
          "Buyer confirmed",
          "$160,000 funding ready"
        ]
      },
      "buyer": {
        "title": "Buyer view",
        "items": [
          "Invoice reviewed",
          "Payment obligation confirmed",
          "Due in 60 days"
        ]
      },
      "underwriter": {
        "title": "Underwriter view",
        "items": [
          "Risk grade B+",
          "Documents verified",
          "Recommended advance 80%"
        ]
      },
      "funder": {
        "title": "Funder view",
        "items": [
          "$160,000 deployment",
          "60-day tenor",
          "Repayment source: buyer payment"
        ]
      }
    },
    "steps": [
      {
        "title": "Seller submits invoice",
        "detail": "Chinese supplier uploads invoice, contract, shipment evidence and buyer details."
      },
      {
        "title": "Buyer confirms obligation",
        "detail": "Kazakh buyer confirms the invoice, payment date and non-dispute status."
      },
      {
        "title": "TradeFlow underwrites",
        "detail": "Seller, buyer, invoice evidence, tenor, corridor and fraud controls are scored."
      },
      {
        "title": "Funder finances receivable",
        "detail": "Bank, factor or fund deploys $160,000 against the approved receivable."
      },
      {
        "title": "Buyer repays at maturity",
        "detail": "Buyer pays $200,000 after 60 days; funder receives capital and return."
      }
    ],
    "lenderTitle": "В этой демо-сделке TradeFlow не выступает кредитором.",
    "lenderText": "Платформа отвечает за привлечение, андеррайтинг, документы, подтверждения и сервисинг. Банк, фактор или кредитный фонд финансирует дебиторскую задолженность.",
    "cta": "Смотреть процесс"
  },
  "scoring": {
    "empty": "Заполните форму для получения предварительной оценки",
    "fullAssessment": "Получить полную оценку",
    "industryPlaceholder": "Выберите отрасль"
  },
  "how": {
    "title": "Простой путь от счета к финансированию",
    "steps": [
      {
        "title": "Загрузите документы",
        "description": "Счет, контракт, подтверждение отгрузки и корпоративные документы собираются в одном процессе."
      },
      {
        "title": "Получите оценку",
        "description": "TradeFlow оценивает продавца, покупателя, документы, срок и торговый коридор."
      },
      {
        "title": "Подключите партнера",
        "description": "Одобренные задолженности готовятся для банков, факторов или кредитных фондов."
      },
      {
        "title": "Получите финансирование",
        "description": "Продавец получает аванс, а TradeFlow сопровождает сделку до погашения."
      }
    ]
  },
  "stories": {
    "title": "What the demo proves",
    "cards": [
      {
        "quote": "A bank can see the borrower, buyer, evidence package and economics in one place.",
        "author": "Funding partner",
        "company": "Kazakhstan bank / fund",
        "role": "Balance sheet provider"
      },
      {
        "quote": "A supplier can request early payment without becoming the lender or negotiating manually with each institution.",
        "author": "Chinese exporter",
        "company": "Demo Machinery Co.",
        "role": "Seller"
      },
      {
        "quote": "A buyer can confirm the commercial obligation and payment date without changing the trade relationship.",
        "author": "Kazakh importer",
        "company": "Demo Distribution LLP",
        "role": "Buyer"
      }
    ]
  },
  "offers": {
    "title": "Partner roles TradeFlow is seeking",
    "cards": [
      {
        "title": "Funding partners",
        "description": "Banks, factors and private credit funds that want qualified cross-border invoices.",
        "company": "Capital providers",
        "offer_type": "financing"
      },
      {
        "title": "Origination partners",
        "description": "Logistics, exporter and importer networks that can surface real transactions.",
        "company": "Distribution partners",
        "offer_type": "logistics"
      },
      {
        "title": "Institutional pilots",
        "description": "Kazakhstan trade-finance teams willing to test underwriting requirements on demo cases.",
        "company": "Pilot partners",
        "offer_type": "service"
      }
    ],
    "detail": "Details"
  },
  "footer": {
    "tagline": "Цифровое привлечение, андеррайтинг и сервисинг трансграничного receivables finance.",
    "companyHeading": "Компания",
    "servicesHeading": "Услуги",
    "legalHeading": "Правовая информация",
    "careers": "Партнерство",
    "factoring": "Финансирование дебиторки",
    "tradeFinance": "Trade finance workflow",
    "bnpl": "Институциональные funding rails"
  },
  "home": {
    "nav": {
      "demo": "Демо-мәміле"
    },
    "hero": {
      "badge": "Жаһандық инвойс-қаржыландыру платформасы",
      "statSpeedValue": "60к",
      "statSpeedLabel": "Әдеттегі төлем мерзімі",
      "statAdvanceValue": "80%",
      "statAdvanceLabel": "Мысал аванс мөлшері",
      "statPartnersValue": "4",
      "statPartnersLabel": "Процесс қатысушысы",
      "approvedTitle": "Демо-берешек мақұлданды",
      "approvedMeta": "$160,000 қаржыландыру өтінімі"
    },
    "demo": {
      "badge": "Иллюстрациялық демо-мәміле",
      "title": "Бір трансшекаралық инвойс: өтінімнен өтеуге дейін",
      "subtitle": "Бұл нақты мәміле емес. Бұл TradeFlow банктер, факторинг компаниялары және private credit серіктестері үшін ұйымдастырып, андеррайтинг жасап, сүйемелдей алатын транзакция үлгісі.",
      "caseTitle": "Демо-кейс: өнеркәсіптік жабдық шоты",
      "sellerLabel": "Қытайлық сатушы",
      "buyerLabel": "Қазақстандық сатып алушы",
      "corridorLabel": "Дәліз",
      "statusLabel": "Мәртебе",
      "statusValue": "Қаржыландыруға мақұлданды",
      "metrics": {
        "invoice": "Шот",
        "term": "Төлем мерзімі",
        "advance": "Аванс",
        "financing": "Қажет қаржыландыру",
        "pricing": "Баға бағдары",
        "fee": "TradeFlow комиссиясы"
      },
      "roles": {
        "seller": {
          "title": "Сатушы кабинеті",
          "items": [
            "Шот жүктелді",
            "Сатып алушы растады",
            "$160,000 қаржыландыруға дайын"
          ]
        },
        "buyer": {
          "title": "Сатып алушы кабинеті",
          "items": [
            "Шот тексерілді",
            "Төлем міндеттемесі расталды",
            "Төлем мерзімі - 60 күн"
          ]
        },
        "underwriter": {
          "title": "Андеррайтер кабинеті",
          "items": [
            "Тәуекел рейтингі B+",
            "Құжаттар тексерілді",
            "Ұсынылған аванс 80%"
          ]
        },
        "funder": {
          "title": "Фондер кабинеті",
          "items": [
            "$160,000 орналастыру",
            "Мерзімі 60 күн",
            "Өтеу көзі: сатып алушы төлемі"
          ]
        }
      },
      "steps": [
        {
          "title": "Сатушы шотты береді",
          "detail": "Қытайлық жеткізуші шотты, келісімшартты, жөнелту дәлелін және сатып алушы деректерін жүктейді."
        },
        {
          "title": "Сатып алушы міндеттемені растайды",
          "detail": "Қазақстандық сатып алушы шотты, төлем күнін және даудың жоқ екенін растайды."
        },
        {
          "title": "TradeFlow андеррайтинг жасайды",
          "detail": "Сатушы, сатып алушы, құжаттар, мерзім, дәліз және алаяқтық белгілері бағаланады."
        },
        {
          "title": "Қаржы серіктесі берешекті қаржыландырады",
          "detail": "Банк, фактор немесе қор мақұлданған берешекке $160,000 орналастырады."
        },
        {
          "title": "Сатып алушы мерзімінде төлейді",
          "detail": "60 күннен кейін сатып алушы $200,000 төлейді; фондер капитал мен табыс алады."
        }
      ],
      "lenderTitle": "Бұл демо-мәміледе TradeFlow кредитор ретінде көрсетілмейді.",
      "lenderText": "Платформа тарту, андеррайтинг, құжаттар, растаулар және сервисинг үшін жауап береді. Берешекті банк, фактор немесе кредиттік қор қаржыландырады.",
      "cta": "Процесті көру"
    },
    "roles": {
      "badge": "Платформадағы рөлдер",
      "title": "Мәміледегі рөліңізді таңдаңыз",
      "subtitle": "TradeFlow бір жалпы аккаунтқа емес, трансшекаралық дебиторлық қаржыландырудағы нақты қатысушыларға арналған.",
      "cta": "Дұрыс рөлмен тіркелу",
      "items": [
        {
          "title": "Сатушы / экспорттаушы",
          "description": "Шоттарды, келісімшарттарды және жөнелту дәлелдерін жүктейді; расталған дебиторлық берешекке ерте төлем сұрайды."
        },
        {
          "title": "Сатып алушы / импорттаушы",
          "description": "Фондер міндеттемеге сүйене алуы үшін шоттың дұрыстығын, төлем күнін және даудың жоқ екенін растайды."
        },
        {
          "title": "Ориджинатор / агент",
          "description": "Сатушыларды, сатып алушыларды немесе сауда мәмілелерін әкеледі және қаржыландыру пакетін дайындауға көмектеседі."
        },
        {
          "title": "Инвестор",
          "description": "Капитал бөлмес бұрын мақұлданған берешектерді, экономиканы, мерзімді және тәуекел рейтингін қарайды."
        },
        {
          "title": "Банк / қаржы серіктесі",
          "description": "TradeFlow тарту, процесс және сервисингті жүргізген кезде қаржыландыру немесе факторинг лимитін береді."
        }
      ]
    },
    "scoring": {
      "empty": "Алдын ала бағалау алу үшін форманы толтырыңыз",
      "fullAssessment": "Толық бағалауды сұрау",
      "industryPlaceholder": "Саланы таңдаңыз",
      "companyPlaceholder": "Demo Trading LLP",
      "revenuePlaceholder": "500000",
      "invoicesPlaceholder": "200000"
    },
    "how": {
      "title": "Шоттан қаржыландыруға дейінгі қарапайым жол",
      "steps": [
        {
          "title": "Құжаттарды жүктеу",
          "description": "Шот, келісімшарт, жөнелту дәлелі және корпоративтік құжаттар бір процесте жиналады."
        },
        {
          "title": "Бағалау алу",
          "description": "TradeFlow сатушыны, сатып алушыны, құжаттарды, мерзімді және сауда дәлізін бағалайды."
        },
        {
          "title": "Қаржы серіктесімен сәйкестендіру",
          "description": "Мақұлданған берешектер банктерге, факторларға немесе кредиттік қорларға дайындалады."
        },
        {
          "title": "Қаржыландыру алу",
          "description": "Сатушы аванс алады, ал TradeFlow мәмілені өтеуге дейін сүйемелдейді."
        }
      ]
    },
    "stories": {
      "title": "TradeFlow нені көрсетеді",
      "cards": [
        {
          "quote": "Банк қарыз алушыны, сатып алушыны, дәлелдер пакетін және мәміле экономикасын бір жерден көреді.",
          "author": "Қаржы серіктесі",
          "company": "Қазақстан банкі / қоры",
          "role": "Капитал жеткізуші"
        },
        {
          "quote": "Жеткізуші әр қаржы институтымен жеке келіссөз жүргізбей, ерте төлем сұрай алады.",
          "author": "Қытайлық экспорттаушы",
          "company": "Demo Machinery Co.",
          "role": "Сатушы"
        },
        {
          "quote": "Сатып алушы сауда қатынасын өзгертпей, коммерциялық міндеттемені және төлем күнін растайды.",
          "author": "Қазақстандық импорттаушы",
          "company": "Demo Distribution LLP",
          "role": "Сатып алушы"
        }
      ]
    },
    "offers": {
      "title": "TradeFlow іздеп отырған серіктестер",
      "detail": "Толығырақ",
      "cards": [
        {
          "title": "Қаржы серіктестері",
          "description": "Іріктелген трансшекаралық инвойстарды қалайтын банктер, факторлар және private credit қорлары.",
          "company": "Капитал жеткізушілері",
          "offer_type": "financing"
        },
        {
          "title": "Мәміле тарту серіктестері",
          "description": "Нақты мәмілелерді таба алатын логистика, экспорт және импорт желілері.",
          "company": "Дистрибуция серіктестері",
          "offer_type": "logistics"
        },
        {
          "title": "Институционалдық пилоттар",
          "description": "Демо-кейстер арқылы андеррайтинг талаптарын сынауға дайын Қазақстандағы сауда қаржыландыру командалары.",
          "company": "Пилот серіктестер",
          "offer_type": "service"
        }
      ]
    },
    "footer": {
      "tagline": "Трансшекаралық дебиторлық қаржыландыру үшін цифрлық тарту, андеррайтинг және сервисинг.",
      "companyHeading": "Компания",
      "servicesHeading": "Қызметтер",
      "legalHeading": "Құқықтық ақпарат",
      "careers": "Серіктестік",
      "factoring": "Дебиторлық қаржыландыру",
      "tradeFinance": "Сауда қаржыландыру процесі",
      "bnpl": "Институционалдық қаржыландыру инфрақұрылымы"
    }
  },
    "authPage": {
      "sideTitle": "Трансшекаралық сауданың өсуі үшін айналым капиталы",
      "sideSubtitle": "Трансшекаралық B2B мәмілелері үшін инвойс-қаржыландыру процесіне қол жеткізу.",
      "financed": "Демо көлем",
      "clients": "Қатысушылар",
      "speedValue": "60к",
      "speed": "Әдеттегі мерзім",
      "loginDescription": "Аккаунтыңызға кіріңіз",
      "registerDescription": "Жұмысты бастау үшін аккаунт жасаңыз",
      "welcome": "Қош келдіңіз",
      "loginError": "Кіру қатесі",
      "passwordsMismatch": "Құпиясөздер сәйкес емес",
      "passwordTooShort": "Құпиясөз кемінде 6 таңбадан тұруы керек",
      "registerSuccess": "Тіркелу сәтті аяқталды",
      "registerError": "Тіркелу қатесі",
      "fullNamePlaceholder": "Иван Петров",
      "companyPlaceholder": "Demo Trading LLP",
      "showPasswords": "Құпиясөздерді көрсету",
      "hidePasswords": "Құпиясөздерді жасыру"
    },
    "dashboard": {
      "clients": "Клиенттер",
      "portfolio": "Портфель",
      "search": "Іздеу...",
      "welcome": "Қош келдіңіз",
      "accountSummary": "Аккаунтыңыздағы ағымдағы жағдай",
      "notCompleted": "Өтілмеген",
      "users": "Пайдаланушылар",
      "recentDeals": "Соңғы мәмілелер",
      "noDeals": "Мәмілелер жоқ",
      "profile": "Профиль",
      "name": "Аты",
      "company": "Компания",
      "phone": "Телефон",
      "interfaceLanguage": "Интерфейс тілі",
      "socialAccounts": "Әлеуметтік желілер",
      "linkedAccounts": "Кіру үшін байланыстырылған аккаунттар",
      "languageChanged": "Тіл өзгертілді",
      "monthlyRevenue": "Айлық түсім",
      "totalDeals": "Барлық мәмілелер",
      "conversion": "Конверсия",
      "keyMetrics": "Негізгі көрсеткіштер",
      "invoicesMetric": "Шот-фактуралар",
      "activeUsers": "Белсенді",
      "blockedUsers": "Бұғатталған",
      "blockUser": "Бұғаттау",
      "unblockUser": "Бұғаттан шығару",
      "offersSoon": "Ұсыныстарды басқару жақында қолжетімді болады",
      "blogSoon": "Блогты басқару жақында қолжетімді болады",
      "table": {
        "amount": "Сома",
        "advance": "Аванс",
        "status": "Мәртебе",
        "date": "Күні",
        "title": "Атауы",
        "type": "Түрі",
        "size": "Өлшемі",
        "number": "Нөмір",
        "debtor": "Дебитор",
        "dueDate": "Төлем мерзімі",
        "fee": "Комиссия",
        "role": "Рөл"
      },
      "documents": {
        "uploadTitle": "Құжат жүктеу",
        "type": "Құжат түрі",
        "title": "Атауы",
        "description": "Сипаттама",
        "file": "Файл",
        "selectFile": "Файл таңдаңыз",
        "loadError": "Құжаттарды жүктеу қатесі",
        "uploadSuccess": "Құжат жүктелді",
        "uploadError": "Жүктеу қатесі",
        "deleteSuccess": "Құжат жойылды",
        "deleteError": "Жою қатесі",
        "invoice": "Шот-фактура",
        "financial_statement": "Қаржылық есеп",
        "bank_statement": "Банк үзіндісі",
        "incorporation": "Құрылтай құжаттары",
        "contract": "Келісімшарт",
        "other": "Басқа"
      },
      "invoices": {
        "createTitle": "Жаңа шот-фактура",
        "number": "Шот нөмірі",
        "debtor": "Дебитор",
        "issueDate": "Шығарылған күні",
        "dueDate": "Төлем мерзімі",
        "factoring": "Факторинг",
        "loadError": "Шоттарды жүктеу қатесі",
        "createSuccess": "Шот жасалды",
        "createError": "Шот жасау қатесі",
        "factoringSuccess": "Факторинг өтінімі жіберілді"
      },
      "deals": {
        "loadError": "Мәмілелерді жүктеу қатесі",
        "approveSuccess": "Мәміле мақұлданды",
        "fundSuccess": "Мәміле қаржыландырылды"
      },
      "usersTab": {
        "loadError": "Пайдаланушыларды жүктеу қатесі",
        "statusChanged": "Мәртебе өзгертілді"
      },
      "status": {
        "pending_approval": "Қаралуда",
        "pending_review": "Тексерілуде",
        "pending": "Қаралуда",
        "approved": "Мақұлданды",
        "funded": "Қаржыландырылды",
        "rejected": "Қабылданбады",
        "active": "Белсенді"
      },
      "genericError": "Қате"
    }
};

export default kk;
